import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { OpenerContent } from './opener/OpenerContent';

export const Opener = (props) => {
  const {
    isOpen: defaultOpen,
    onToggle,
    className = '',
    btnClassName = '',
    contentClassName = '',
    btn,
    content,
    contentClose = true,
    isAlwaysOpen = false,
    getToggleContent = () => {},
    disabled = false,
    stopClickPropagation = true,
  } = props;

  const [isOpen, setIsOpen] = useState(defaultOpen);
  const btnRef = useRef();

  const toggleContent = (isOpenValue) => {
    setIsOpen(typeof isOpenValue === 'boolean' ? isOpenValue : !isOpen);
  };

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  useEffect(() => {
    getToggleContent(toggleContent);
  }, []);

  useEffect(() => {
    if (onToggle) {
      onToggle(isOpen);
    }
  }, [isOpen]);

  const closeContent = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <div className={`${className} ${isOpen ? '_opened' : ''}`}>
      <div
        className={btnClassName}
        ref={btnRef}
        onClick={(e) => {
          if (stopClickPropagation) {
            e.stopPropagation();
          }
          if (disabled) {
            return;
          }
          toggleContent();
        }}
      >
        {btn}
      </div>
      <OpenerContent
        className={`${contentClassName}`}
        isOpen={isOpen || isAlwaysOpen}
        btn={btnRef.current}
        handleClickOutside={closeContent}
        close={contentClose ? closeContent : ''}
      >
        {content}
      </OpenerContent>
    </div>
  );
};

Opener.propTypes = {
  className: PropTypes.string,
  onToggle: PropTypes.func,
  btnClassName: PropTypes.string,
  contentClassName: PropTypes.string,
  btn: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.oneOf([null])]),
  isOpen: PropTypes.bool,
  getToggleContent: PropTypes.func,
  contentClose: PropTypes.bool,
  isAlwaysOpen: PropTypes.bool,
  disabled: PropTypes.bool,
  stopClickPropagation: PropTypes.bool,
};
